import { createApi } from "@reduxjs/toolkit/query/react";
import { buildBaseQuery } from "@app/api";

import { ConfigPayload, ConfigsResponse } from "../types/index";

export const configApi = createApi({
  reducerPath: "configApi",
  baseQuery: buildBaseQuery(""),
  endpoints: (builder) => ({
    getConfigs: builder.query<{ data: ConfigsResponse }, void>({
      query: () => {
        return `/configs`;
      },
    }),
    updateConfig: builder.mutation<void, { body: ConfigPayload }>({
      query: ({ body }) => ({
        url: `/configs`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetConfigsQuery,
  useLazyGetConfigsQuery,
  useUpdateConfigMutation,
} = configApi;
